/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M23 23 1 1l22 22z" fill="currentcolor" />
      <path
        d="m1.707.293 22 22-1.414 1.414L19.586 21H1V6h2v13h14.586L.293 1.707 1.707.293zM23 3v14h-2l-.001-10.826-5.348 4.585-1.302-1.518L19.296 5H9V3h14z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEmailOff as EmailOff };
